/**
 * Configuración de Versión del Sistema San Roque v2
 */
export const APP_VERSION = '2.22.2'
